import { useTranslation } from 'react-i18next'

import { Label, MultiSelect, Select } from '@mercai/clever'

import { ProductsIndustryFormProps } from './products-industry-form.type'

import styles from './products-industry-form.module.css'
import {
  LeadCompanyManufacturedProductEnum,
  LeadIndustryEnum,
  LeadMaterialEnum,
} from '@/types'

export const ProductsIndustryForm = ({
  onValuesChange,
  values,
}: ProductsIndustryFormProps) => {
  const { t } = useTranslation('screenProfileShow')

  const handleOnChangeValues = (
    key: string,
    value: string | number | boolean | string[],
  ) => {
    if (Array.isArray(value)) {
      value = value.join(',')
    }

    onValuesChange({ ...values, [key]: value })
  }

  return (
    <div className={styles.core}>
      <div className={styles['form-group']}>
        <Label>{t('productsIndustryFormProductOfInterestLabel')}</Label>
        <MultiSelect
          values={
            values?.productOfInterest
              ? values?.productOfInterest?.split(',')
              : ['']
          }
          onChange={(value) => handleOnChangeValues('productOfInterest', value)}
          options={[
            { value: '', label: t('selectOptionEmpty') },
            ...Object.keys(LeadMaterialEnum).map((key) => ({
              value: key,
              label: key,
            })),
          ]}
          placeholder={t('selectPlaceholder')}
        />
      </div>

      <div className={styles['form-group']}>
        <Label>{t('productsIndustryFormIndustryLabel')}</Label>
        <Select
          value={values?.industry}
          onChange={(value) => handleOnChangeValues('industry', value)}
          options={[
            { value: '', label: t('selectOptionEmpty') },
            ...Object.keys(LeadIndustryEnum).map((key) => ({
              value: key,
              label: key,
            })),
          ]}
          placeholder={t('selectPlaceholder')}
        />
      </div>

      <div className={styles['form-group']}>
        <Label>{t('productsIndustryFormCompanyProducesLabel')}</Label>
        <Select
          value={values?.companyManufacturedProduct}
          onChange={(value) =>
            handleOnChangeValues('companyManufacturedProduct', value)
          }
          options={[
            { value: '', label: t('selectOptionEmpty') },
            ...Object.keys(LeadCompanyManufacturedProductEnum).map((key) => ({
              value: key,
              label: key,
            })),
          ]}
          placeholder={t('selectPlaceholder')}
        />
      </div>
    </div>
  )
}
